import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Eye, Loader2, X, Download } from "lucide-react";

export default function PdfPreviewCard() {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const r = await api.get("/settings/pdf-apercu", { params: { format: "png" }, responseType: "blob" });
      if (url) URL.revokeObjectURL(url);
      setUrl(URL.createObjectURL(r.data));
    } catch { toast.error("Impossible de générer l'aperçu"); }
    finally { setBusy(false); }
  };

  const openPdf = async () => {
    try {
      const r = await api.get("/settings/pdf-apercu", { responseType: "blob" });
      const u = URL.createObjectURL(r.data);
      Object.assign(document.createElement("a"), { href: u, download: "apercu-proces-verbal.pdf" }).click();
      setTimeout(() => URL.revokeObjectURL(u), 5000);
    } catch { toast.error("Impossible de générer le PDF"); }
  };

  return (
    <div className="bg-white rounded-lg border border-dd-light p-6" data-testid="pdf-preview-card">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-lg bg-dd-blue/10 flex items-center justify-center shrink-0"><Eye className="text-dd-blue" size={22} /></div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-dd-blue">Aperçu du PDF</h3>
          <p className="text-sm text-dd-warm mt-1">Procès-verbal d'exemple généré avec votre logo, vos couleurs, votre police et vos coordonnées. Enregistrez d'abord vos modifications.</p>
          <div className="flex gap-2 mt-4">
            <Button onClick={load} disabled={busy} className="h-11 bg-dd-blue hover:bg-dd-hover text-white" data-testid="pdf-preview-btn">
              {busy ? <Loader2 size={16} className="mr-1 animate-spin" /> : <Eye size={16} className="mr-1" />} {url ? "Actualiser l'aperçu" : "Afficher l'aperçu"}
            </Button>
            {url && <Button variant="outline" onClick={openPdf} className="h-11 border-dd-blue text-dd-blue" data-testid="pdf-preview-download"><Download size={16} className="mr-1" /> Télécharger le PDF complet</Button>}
            {url && <Button variant="outline" onClick={() => { URL.revokeObjectURL(url); setUrl(""); }} className="h-11 border-dd-light" data-testid="pdf-preview-close"><X size={16} className="mr-1" /> Fermer</Button>}
          </div>
          {url && <img alt="Aperçu de la première page du PDF" src={url} className="mt-4 w-full max-w-[700px] rounded-md border border-dd-light bg-white" data-testid="pdf-preview-frame" />}
        </div>
      </div>
    </div>
  );
}
